import { ROUTE_CHANGE } from './types';

export const OnRouteChange = (nextRoute) => {
  localStorage.setItem("lipro_route", nextRoute);
  return {
    type: ROUTE_CHANGE,
    payload: { current_route: nextRoute }
  }
}

// export const OnFirstLoginChange = (change) => {
//   return {
//     type: FIRST_LOGIN_CHANGE,
//     payload: change
//   }
// }